import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../utils/seo';

const StadtratswahlPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  const [hoveredCandidate, setHoveredCandidate] = useState<number | null>(null);

  useSEO({
    title: 'Stadtratswahl Bad Windsheim 2026 - AfD Informationen',
    description: 'Alle wichtigen Informationen zur Stadtratswahl 2026 in Bad Windsheim. Erfahren Sie, wie Sie die AfD-Liste 3 wählen und unsere 8 Kandidaten unterstützen können.',
    keywords: 'Stadtratswahl Bad Windsheim, Kommunalwahl 2026, AfD Liste 3, Stadtrat wählen, Bad Windsheim',
    canonical: `${siteUrl}/stadtratswahl`,
    schema: {
      '@context': 'https://schema.org',
      '@type': 'Event',
      name: 'Stadtratswahl Bad Windsheim 2026',
      description: 'Kommunalwahl für den Stadtrat Bad Windsheim',
      startDate: '2026-03-15',
      location: {
        '@type': 'Place',
        name: 'Bad Windsheim',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Bad Windsheim',
          addressRegion: 'Bayern',
          addressCountry: 'DE'
        }
      },
      organizer: {
        '@type': 'Organization',
        name: 'Stadt Bad Windsheim'
      }
    }
  });

  const stadtratCandidates = [
    {
      id: 1,
      name: "Dennis Neumeister",
      position: "Bauzeichner, 26 Jahre",
      image: "https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Dennis+Neumeister-1920w.jpg",
      description: "Ich bin 26 Jahre alt, gelernter Bauzeichner und studiere derzeit Bauingenieurwesen neben meiner Tätigkeit in einem Planungsbüro. Meine Zeit im Internat sowie der freiwillige Wehrdienst bei der Bundeswehr haben mich geprägt und mir früh vermittelt, wie wichtig Teamfähigkeit, Disziplin und Verlässlichkeit sind. Als Spitzenkandidat möchte ich mich im Stadtrat für eine traditionsreiche, familienfreundliche und lebendige Stadt einsetzen. Für mich stehen Verantwortung und Transparenz im Mittelpunkt politischen Handelns. Gemeinsam möchte ich mit Ihrem Vertrauen die Region stärken und mutig die Herausforderungen von morgen angehen. Veränderung beginnt nicht nur in Berlin, sondern auch hier bei uns. Lasst uns zusammen vor Ort etwas bewegen!"
    },
    {
      id: 2,
      name: "Monika Hartmann",
      position: "Verkäuferin, 39 Jahre",
      image: "https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Monika+Hartmann-1920w.jpg",
      description: "Ich bin in Bad Windsheim geboren und lebe - bis auf zwei Jahre - schon mein ganzes Leben hier. Ich bin verheiratet und habe zwei jugendliche Kinder. Unsere Stadt ist mein Zuhause. Ich möchte mit anpacken, Probleme offen ansprechen und dafür sorgen, dass unsere Stadt sich ehrlich, transparent und sinnvoll weiterentwickelt. Hier ist in den letzten Jahren viel Gutes entstanden, aber auch manches nicht so gelaufen. Darum möchte ich mich für Sie im Stadtrat engagieren."
    },
    {
      id: 3,
      name: "Dr. Benno Bulitta",
      position: "Dipl.-Volkswirt, 75 Jahre",
      image: "https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/009+Dr.+Benno+Bulitta-1920w.jpeg",
      description: "Ich möchte mich unter anderem besonders für die Barrierefreiheit in Bad Windsheim und als ehemaliger Leiter des Kreisfremdenverkehrsamtes für die Förderung des Tourismus und der Gastronomie in unserer Stadt und in unserem Landkreis engagieren. Dabei darf ich auf 22 Jahre als Stadt-und Kreisrat zurückblicken und als 'Senior' meine Erfahrungen an die junge Generation weitergeben."
    },
    {
      id: 4,
      name: "Thomas Nölp",
      position: "Industriemechaniker, 33 Jahre",
      image: "https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Thomas+N%C3%B6lp+kleiner-1920w.jpg",
      description: "Als Familienvater werde ich mich im Stadtrat für die Wohnungsvergabe bei städtischen Immobilien mit preiswerten Mieten vor allem kinderreiche Familien und für preiswerte kleinere Wohnungen für Senioren einsetzen. Auch soll Sorge dafür getragen werden, dass kommunale Immobilien auch regelmäßig gepflegt werden, zum Beispiel bei Schimmel und undichten Dächern."
    },
    {
      id: 5,
      name: "Ramona Nölp",
      position: "Verkäuferin, 43 Jahre",
      image: "https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Ramona-1920w.jpg",
      description: "Für eine ausgewogene Familienpolitik und für Kitas, in denen die Kinder noch Kinder sein dürfen. Keine ideologisch geprägten Erziehungsmaßnahmen, sondern echte und liebevolle Zuwendung. Den Waldkindergarten finde ich Spitze, weil die Kinder dort frühzeitig lernen, mit der Natur umzugehen und sich für die Bewahrung der Umwelt einzusetzen."
    },
    {
      id: 6,
      name: "Silvio Grube",
      position: "Sicherheitsmitarbeiter, 46 Jahre",
      image: "https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Silvio+Bild-1920w.jpg",
      description: "Ich werde mich dafür einsetzen, dass unsere Straßen und Anlagen sicherer sind. Dazu gehören meines Erachtens auch eine Videoüberwachung und Aufzeichnungen, die bei einer Straftat verwendet werden können. Ich sehe darin eine Abschreckung, die dazu führen soll, dass diese Straftaten erst gar nicht vorkommen."
    },
    {
      id: 7,
      name: "Karen Wittich",
      position: "Sicherheitsmitarbeiterin, 34 Jahre",
      image: "https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Karen+Bild-1920w.jpg",
      description: "Ich muss immer an die Frauen denken, die in der Dunkelheit alleine unterwegs sein müssen. Deshalb ist für mich eine gute Straßenbeleuchtung notwendig. Dabei dürfen die Ortsteile auch nicht ausgeschlossen werden. Auch will ich mich dafür einsetzen, dass Frauen den Mut haben, Vorkommnisse zu melden. Dafür braucht es auch im Stadtrat Menschen mit Verständnis und Hilfsbereitschaft."
    },
    {
      id: 8,
      name: "Bennie Crawford",
      position: "Baufinanzierungsberater, 24 Jahre",
      image: "https://static.readdy.ai/image/2461e108107748ba3465ce747c79b9cd/c79e98efbee9b89c3d670c5b0fbf4a33.png",
      description: "Damit Bad Windsheim für junge Menschen eine Heimat mit Zukunft bleibt, brauchen wir attraktiven Wohnraum statt schleichendem Verfall. Als aktiver Baufinanzierungsberater mache ich mich dafür stark, dass Wohnraum für uns Bürger geschaffen und unsere städtische Identität geschützt wird. Weiterhin setze ich mich konsequent dafür ein, dass Sicherheit und der Erhalt unserer Heimat bei jeder Entscheidung Vorrang haben."
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative py-32 bg-gradient-to-br from-primary-600 to-primary-800 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="inline-flex items-center gap-2 mb-6 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
            <div className="w-2 h-2 bg-white rounded-full"></div>
            <span className="text-sm font-semibold tracking-wider uppercase">Kommunalwahl 2026</span>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Informationen zur Stadtratswahl
          </h1>
          <p className="text-xl text-primary-100 max-w-3xl">
            Alles Wichtige zur Stadtratswahl in Bad Windsheim und wie Sie uns unterstützen können.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          
          {/* Logo */}
          <div className="text-center mb-16">
            <div className="relative inline-block">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200 to-secondary-200 rounded-2xl opacity-20"></div>
              <img 
                src="https://static.readdy.ai/image/2461e108107748ba3465ce747c79b9cd/ad92e76f525a3092b6db20d0bc38e3ae.png"
                alt="AfD Bad Windsheim Logo"
                className="relative w-full max-w-2xl mx-auto rounded-2xl shadow-2xl border-4 border-white"
              />
            </div>
          </div>

          {/* Program Overview */}
          <div className="mb-16">
            <h2 className="text-4xl font-bold mb-8 text-gray-900 text-center">Unser Programm für Bad Windsheim</h2>
            
            <div className="space-y-8">
              <div>
                <h3 className="text-2xl font-bold mb-4 text-secondary-600">Bürgernähe und Offenheit</h3>
                <div className="bg-gradient-to-br from-primary-50 to-white p-6 rounded-xl space-y-4 border-l-4 border-primary-600">
                  <div>
                    <h4 className="font-bold text-lg mb-2">Bürgerbefragungen:</h4>
                    <p className="text-gray-700">Ihre Meinung zählt! Wir möchten regelmäßig Ihre Anregungen und Ideen durch Befragungen einholen, um die Stadtentwicklung bürgernah zu gestalten.</p>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2">Unterstützung der Belange aller Ortsteile:</h4>
                    <p className="text-gray-700">Regelmäßige Ortsteil-Begehungen mit allen Vertretern der Fraktionen und der Stadtverwaltung sowie den betroffenen Bürgern.</p>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2">Verbesserung der Infrastruktur:</h4>
                    <p className="text-gray-700">Wir kümmern uns um die Pflege und den Ausbau unserer Straßen, Radwege und Barrierefreiheit.</p>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2">Verbindliche Satzungen für Behinderte und Senioren:</h4>
                    <p className="text-gray-700">Barrierefreiheit und Seniorenfreundlichkeit sind uns wichtig. Wir schaffen klare Rahmenbedingungen für ein inklusives Miteinander.</p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-4 text-secondary-600">Migration und Integration</h3>
                <div className="bg-gradient-to-br from-primary-50 to-white p-6 rounded-xl border-l-4 border-primary-600">
                  <p className="text-gray-700 mb-4">Wir stehen für eine offene Gesellschaft, die jedoch klare Regeln und Erwartungen an alle stellt, die hier leben möchten.</p>
                  <ul className="space-y-3 text-gray-700">
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-secondary-600 text-xl mt-1"></i>
                      <span><strong>Klare Regeln und Rechtsstaatlichkeit:</strong> Konsequente Anwendung bestehender Gesetze</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-secondary-600 text-xl mt-1"></i>
                      <span><strong>Wertebasierte Integration:</strong> Akzeptanz unserer christlichen Werte und Traditionen</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <i className="ri-check-line text-secondary-600 text-xl mt-1"></i>
                      <span><strong>Transparenz bei Ausgaben:</strong> Volle Transparenz über Mittelverwendung</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-4 text-secondary-600">Bezahlbares und attraktives Wohnen</h3>
                <div className="bg-gradient-to-br from-primary-50 to-white p-6 rounded-xl border-l-4 border-primary-600">
                  <p className="text-gray-700 mb-4">Wir setzen auf eine nachhaltige und inklusive Entwicklung:</p>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="bg-white p-4 rounded-lg border-2 border-primary-200">
                      <h4 className="font-bold mb-2 text-primary-700">Bezahlbares Wohnen</h4>
                      <p className="text-sm text-gray-600">Unterstützung von Investitionen, Sanierung, Familien bevorzugen</p>
                    </div>
                    <div className="bg-white p-4 rounded-lg border-2 border-primary-200">
                      <h4 className="font-bold mb-2 text-primary-700">Sicherheit</h4>
                      <p className="text-sm text-gray-600">Bessere Beleuchtung, mehr Sicherheitspräsenz</p>
                    </div>
                    <div className="bg-white p-4 rounded-lg border-2 border-primary-200">
                      <h4 className="font-bold mb-2 text-primary-700">Verkehrsanbindung</h4>
                      <p className="text-sm text-gray-600">Optimale Anbindung, schnelles Internet</p>
                    </div>
                    <div className="bg-white p-4 rounded-lg border-2 border-primary-200">
                      <h4 className="font-bold mb-2 text-primary-700">Stadtentwicklung</h4>
                      <p className="text-sm text-gray-600">Gewerbegebiete, Parkraum-Konzept</p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-4 text-secondary-600">Gesundheit</h3>
                <div className="bg-gradient-to-br from-primary-50 to-white p-6 rounded-xl border-l-4 border-primary-600">
                  <p className="text-gray-700"><strong>Starkes Krankenhaus:</strong> Wir setzen uns für den Erhalt und Ausbau unseres Krankenhauses als unverzichtbarer Bestandteil der medizinischen Versorgung ein. Preisgünstige Praxisräume für die ambulante medizinische Versorgung.</p>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-4 text-secondary-600">Umweltschutz</h3>
                <div className="bg-gradient-to-br from-primary-50 to-white p-6 rounded-xl border-l-4 border-primary-600">
                  <p className="text-gray-700">Alle Umweltschutzmaßnahmen der Stadt und des Kreises müssen sinnvoll, bezahlbar und wohl durchdacht sein. Für alle Umweltschutzmaßnahmen müssen deshalb auch Alternativen überprüft werden.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Flyer Images */}
          <div className="mb-16 text-center">
            <h2 className="text-3xl font-bold mb-8 text-gray-900">Unser Wahlprogramm</h2>
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              Erfahren Sie mehr über unsere Ziele und Positionen für Bad Windsheim
            </p>
            <Link 
              to="/programm" 
              className="inline-flex items-center gap-2 bg-secondary-600 hover:bg-secondary-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
            >
              Zum vollständigen Programm
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* Questions Image */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold mb-8 text-gray-900 text-center">Fragen an die Bürgermeister-Kandidaten</h2>
            <div className="rounded-xl overflow-hidden shadow-xl border-4 border-white">
              <img 
                src="https://le-cdn.website-editor.net/f4f5b2f6065c4ec2b536c829d952713f/dms3rep/multi/opt/Fragen+an+BGM-Kandidaten-1920w.jpg"
                alt="Fragen an Bürgermeister-Kandidaten"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Additional Impressions */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold mb-8 text-gray-900 text-center">Weitere Impressionen</h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="rounded-xl overflow-hidden shadow-xl border-4 border-white">
                <img 
                  src="https://static.readdy.ai/image/2461e108107748ba3465ce747c79b9cd/5fca8c20e71d9258e0e507828933b961.jpeg"
                  alt="Weitere Impressionen"
                  className="w-full h-auto"
                />
              </div>
              <div className="rounded-xl overflow-hidden shadow-xl border-4 border-white">
                <img 
                  src="https://static.readdy.ai/image/2461e108107748ba3465ce747c79b9cd/1f383ff25a407f04e8de7cd4a75d9804.jpeg"
                  alt="Weitere Impressionen"
                  className="w-full h-auto"
                />
              </div>
            </div>
          </div>

          {/* Candidates List */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold mb-8 text-gray-900 text-center">Unsere Stadtratskandidaten</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {stadtratCandidates.map((candidate) => (
                <div
                  key={candidate.id}
                  className="relative group cursor-pointer overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 border-2 border-transparent hover:border-primary-300"
                  onMouseEnter={() => setHoveredCandidate(candidate.id)}
                  onMouseLeave={() => setHoveredCandidate(null)}
                >
                  <div className="aspect-[3/4] relative">
                    <img
                      src={candidate.image}
                      alt={candidate.name}
                      className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-110 ${candidate.id === 8 ? 'object-[center_20%] scale-125' : 'object-top'}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-primary-900/90 via-primary-900/50 to-transparent"></div>
                    
                    {/* Default Info */}
                    <div className={`absolute bottom-0 left-0 right-0 p-6 text-white transition-all duration-500 ${hoveredCandidate === candidate.id ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'}`}>
                      <div className="text-2xl font-bold mb-1 text-secondary-400">{candidate.id < 10 ? `0${candidate.id}` : candidate.id}</div>
                      <h3 className="text-xl font-bold mb-2">{candidate.name}</h3>
                      <p className="text-sm text-gray-300">{candidate.position}</p>
                    </div>

                    {/* Hover Info */}
                    <div className={`absolute inset-0 bg-gradient-to-br from-secondary-600 to-secondary-700 p-6 flex flex-col justify-start overflow-y-auto transition-all duration-500 ${hoveredCandidate === candidate.id ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-full'}`}>
                      <div className="text-white">
                        <div className="text-3xl font-bold mb-3">{candidate.id < 10 ? `0${candidate.id}` : candidate.id}</div>
                        <h3 className="text-2xl font-bold mb-3">{candidate.name}</h3>
                        <p className="text-sm mb-4 font-semibold">{candidate.position}</p>
                        <p className="text-sm leading-relaxed">{candidate.description}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* Voting Instructions */}
      <section className="py-24 bg-gradient-to-br from-secondary-600 to-secondary-700 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'1\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")' }}></div>
        </div>
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10">
          <div className="inline-flex items-center gap-2 mb-6 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full">
            <i className="ri-information-line"></i>
            <span className="text-sm font-semibold tracking-wider uppercase">So wählen Sie uns</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            So unterstützen Sie unser Team bei der Stadtratswahl
          </h2>
          <p className="text-2xl mb-8 leading-relaxed">
            Bitte kreuzen Sie einfach die <span className="font-bold underline">Liste 3 - AfD</span> oben an,
          </p>
          <p className="text-xl mb-8 text-red-100">
            dann erhält jeder Kandidat drei Stimmen und Sie haben Ihr volles Stimmen-Potenzial von <span className="font-bold text-white">24 Stimmen</span> ausgenutzt.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link 
              to="/kandidaten" 
              className="bg-white text-secondary-600 hover:bg-gray-100 px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
            >
              Unsere Kandidaten
            </Link>
            <Link 
              to="/" 
              className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-white px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Zur Startseite
            </Link>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-gradient-to-br from-gray-50 to-primary-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-6 text-gray-900">Kontakt</h2>
          <div className="bg-white p-8 rounded-xl shadow-lg border-2 border-primary-200">
            <p className="text-gray-700 mb-2"><strong>Telefonnummer:</strong></p>
            <p className="text-2xl font-bold text-secondary-600 mb-6">0155 - 688 44 604</p>
            <p className="text-gray-700 mb-2"><strong>Verantwortlich für diese Website:</strong></p>
            <p className="text-lg font-semibold mb-1">Dr. Benno Bulitta</p>
            <p className="text-gray-600">Augustinumstraße 4</p>
            <p className="text-gray-600">91438 Bad Windsheim</p>
            <p className="text-gray-600 mt-4">E-Mail: benno.bulitta@web.de</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StadtratswahlPage;
